import { CSSProperties, FC } from 'react';

import { findFirstAlphaCharacter } from '@utilities/findFirstAlphaCharacter';

import { LetterAvatar } from '../LetterAvatar/LetterAvatar';

export interface UserAvatarProps {
  displayName: string;
  avatarUrl?: string;
  size?: number;
  style?: CSSProperties;
}

export const UserAvatar: FC<UserAvatarProps> = ({ displayName, avatarUrl, size = 42, style }) => {
  if (avatarUrl) {
    return (
      <div>
        <img
          src={avatarUrl}
          alt={displayName}
          style={{
            objectFit: 'cover',
            borderRadius: '50%',
            display: 'block',
            height: size,
            width: size,
            ...style,
          }}
        />
      </div>
    );
  }

  const fontSize = (size * 2) / 3;

  return (
    <LetterAvatar
      letter={findFirstAlphaCharacter(displayName)}
      style={{ height: size, width: size, fontSize, ...style }}
    />
  );
};
